import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ButtonLink } from '@components/common/Button';
import { Container } from '@components/common/Container';
import { Section } from '@components/common/Section';
import { usePageTitle } from '@hooks/usePageTitle';
export const NotFoundPage = () => {
    const { t } = useTranslation();
    usePageTitle('notFound.title');
    return (_jsx(Section, { children: _jsx(Container, { children: _jsxs(Content, { children: [_jsx("h1", { children: t('notFound.title') }), _jsx("p", { children: t('notFound.text') }), _jsx(ButtonLink, { to: "/", children: t('navigation.home') })] }) }) }));
};
const Content = styled.div `
  max-width: 620px;

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.colors.navy900};
    font-size: ${({ theme }) => theme.typography.sizes.xxl};
  }

  p {
    color: ${({ theme }) => theme.colors.muted};
    font-size: ${({ theme }) => theme.typography.sizes.lg};
  }
`;
